var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockTabButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E6F7FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_642_19252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_642_19252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.404 16.0124C11.7282 16.0124 12.0024 15.8991 12.2264 15.6724C12.4504 15.4457 12.5625 15.1702 12.5625 14.846C12.5625 14.5217 12.4491 14.2475 12.2224 14.0235C11.9957 13.7995 11.7203 13.6875 11.396 13.6875C11.0717 13.6875 10.7976 13.8008 10.5736 14.0275C10.3495 14.2542 10.2375 14.5297 10.2375 14.8539C10.2375 15.1782 10.3508 15.4523 10.5775 15.6764C10.8042 15.9004 11.0797 16.0124 11.404 16.0124ZM7.57545 19.4249C7.24366 19.4249 6.96064 19.3069 6.72639 19.0707C6.49213 18.8346 6.375 18.5507 6.375 18.2192V11.4807C6.375 11.1492 6.49307 10.8653 6.72921 10.6292C6.96533 10.393 7.24919 10.275 7.58077 10.275H12.675V8.47496C12.675 7.57994 12.9892 6.81869 13.6175 6.19121C14.2458 5.56374 15.008 5.25 15.9042 5.25C16.8004 5.25 17.5613 5.56374 18.1867 6.19121C18.8122 6.81869 19.125 7.57994 19.125 8.47496H18.15C18.15 7.84996 17.9312 7.31871 17.4937 6.88121C17.0562 6.44371 16.525 6.22496 15.9 6.22496C15.275 6.22496 14.7437 6.44371 14.3062 6.88121C13.8687 7.31871 13.65 7.84996 13.65 8.47496V10.275H15.2192C15.5508 10.275 15.8346 10.393 16.0708 10.6292C16.3069 10.8653 16.425 11.1492 16.425 11.4807V18.2192C16.425 18.5507 16.3068 18.8346 16.0705 19.0707C15.8343 19.3069 15.5502 19.4249 15.2184 19.4249H7.57545Z",
    fill: "#00AAFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockTabButton);
export default __webpack_public_path__ + "static/media/Lock Tab Button.388a27356c4629e7c95888433c9176f8.svg";
export { ForwardRef as ReactComponent };